import { useAuthenticator } from '@aws-amplify/ui-react-native';
import { useLoadedUser } from './useUser';
import { useResetApp } from '../../components/ResetAppProvider';
import usePersistedKeyValueStore from '../usePersistedKeyValueStore';
import { UseEnvironmentReturnValue, useEnvironment } from '../useEnvironment';
import { Platform } from 'react-native';

export type Environment = 'dev' | 'prod';

export type UseSetEnvironmentReturnValue = {
    setEnvironment: (environment: Environment) => void;
    canSetEnvironment: boolean;
    environment: UseEnvironmentReturnValue;
};

function useSetEnvironmentMobile(): UseSetEnvironmentReturnValue {
    const { signOut } = useAuthenticator((context) => [context.user]);
    const { user } = useLoadedUser({});
    const resetApp = useResetApp();
    const { setValue } = usePersistedKeyValueStore<Environment>({
        category: 'environment',
        key: 'environment',
        defaultValue: 'prod',
        onPersisted: () => {
            signOut();
            resetApp(200);
        },
    });

    return {
        environment: useEnvironment(),
        setEnvironment: (environment: Environment) => {
            if (!user.isTestUser) return;

            setValue(environment);
        },
        canSetEnvironment: user.isTestUser,
    };
}

function useSetEnvironmentWeb(): UseSetEnvironmentReturnValue {
    return {
        environment: useEnvironment(),
        setEnvironment: () => {},
        canSetEnvironment: false,
    };
}

export const useSetEnvironment = Platform.select({
    web: useSetEnvironmentWeb,
    default: useSetEnvironmentMobile,
});
